import type { ListRacasUseCase } from '@/application/port/in/RacaUseCase';
import type { RacaGateway } from '@/application/port/out/RacaGateway';
import type { Raca } from '@/domain/model/Raca';

export class ListRacasUseCaseImpl implements ListRacasUseCase {
  constructor(private readonly gateway: RacaGateway) {}
  execute(): Promise<Raca[]> {
    return this.gateway.list();
  }
}
